import GetLoading from "../../share/getLoading";
import { useEffect, useState, useRef } from "react";
import {
  PlusCircleOutlined,
  CloseOutlined,
  PrinterOutlined,
  EditOutlined,
  FilterOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import {
  Table,
  Modal,
  Button,
  Input,
  Space,
  Tabs,
  message,
  Tag,
  Popconfirm,
} from "antd";
import "../../styles/Home-module.css";
import "./print.css";
import { request } from "../../share/request";
import { getStatusContent, getTageStyle } from "../../share/getStatusContent";
import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";

import { getCurrentUser, getPermission } from "../../share/getProfile";
import FormPantient from "../caractivity/FormPantient";
import { useReactToPrint } from "react-to-print";
import { BsDownload } from "react-icons/bs";
import FilterDate from "../../share/FilterDate";
import dayjs from "dayjs";

const AccidentForm = () => {
  const printRef = useRef();
  const getProfile = getCurrentUser();
  const [loadingSpin, setLoadingSpin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const [id, setID] = useState("");

  const [list, setList] = useState([]);
  const [total, setTotal] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [objFilter, setObjFileter] = useState({
    search: "",
    page_number: 1,
    item_per_page: 10,
    orgcode: getProfile.org_code,
    date_start: null,
    date_end: null,
  });

  const defaultfield = {
    date_pantient: "",
    date: "",
    month: "",
    year: "",
    place: "",
    sentTo: "",
    name: "",
    gender: "",
    age: "",
    phone: "",
    times: Array(6).fill(null),
    accident: {
      car: false,
      moto: false,
      walk: false,
      police: false,
      people: false,
      doctor: false,
      other: "",
    },
    injury: {
      head: {
        wound: false,
        bleeding: false,
        fracture: false,
        confused: false,
        unconscious: false,
      },
      neck: {
        wound: false,
        bleeding: false,
        fracture: false,
        pupilDilated: false,
        pupilConstricted: false,
      },
      face: { wound: false, bleeding: false, fracture: false },
      chest: {
        wound: false,
        bleeding: false,
        fracture: false,
        explosion: false,
      },
      abdomen: { wound: false, bleeding: false, fracture: false, stab: false },
      back: { wound: false, bleeding: false, fracture: false, poison: false },
      upperLimb: {
        wound: false,
        bleeding: false,
        fracture: false,
        snakeBite: false,
      },
      lowerLimb: {
        wound: false,
        bleeding: false,
        fracture: false,
        drowning: false,
      },
      pelvis: { wound: false, bleeding: false, fracture: false },
      genital: { wound: false, bleeding: false, fracture: false },
      skin: { wound: false, bleeding: false, fracture: false },
      other1: "",
      other2: "",
    },
    diagnosis: {
      noBreath: false,
      breath: false,
      suction: false,
      oxygen: false,
      raiseSway: false,
      raiseSuction: false,
      tube: false,
      washWound: false,
      pcr: false,
      immobilize: false,
      stopBleed: false,
      serum: false,
      diagnosis1: "",
      diagnosis2: "",
      diagnosis3: "",
      diagnosis4: "",
      diagnosis5: "",
      respiratoryRate: "",
      bloodPressure: "",
      pulseRate: "",
      oxygenLevel: "",
      glucoseLevel: "",
      additionalDescription: "",
    },
    org_code: getProfile.org_code,
  };
  const [form, setForm] = useState(defaultfield);
  // -----------------  permisstion page --------------------
  const userPermission = getPermission();
  const accident_formPageValue = userPermission.find(
    (permission) => permission.pagename === "accident_form"
  ) || { add: 0, edit: 0, deleted: 0 };
  const {
    add: Addvalue,
    edit: Editvalue,
    deleted: Deletevalue,
  } = accident_formPageValue;
  // -----------------  end permisstion page --------------------

  const getList = async (objFilter) => {
    setList([]);
    setLoading(true);
    const param = new URLSearchParams({
      search: objFilter.search,
      page_number: objFilter.page_number,
      item_per_page: objFilter.item_per_page,
      orgcode: getProfile.org_code,
    });
    if (objFilter.date_start) param.append("date_start", objFilter.date_start);
    if (objFilter.date_end) param.append("date_end", objFilter.date_end);
    try {
      const res = await request(
        "caractivityaccidentform?" + param.toString(),
        "get",
        {}
      );

      await new Promise((resolve) => setTimeout(resolve, 400));
      console.log(res);
      if (res && res.api_data) {
        const dataList = Array.isArray(res.api_data) ? res.api_data : [];
        setList(dataList);
        setTotal(res.total);
        console.table(dataList);
      }
    } catch (error) {
      console.error("Error fetching:", error);
    } finally {
      setLoading(false);
    }
  };
  // const [printData, setPrintData] = useState([]);
  // const getPrintData = async (id) => {
  //   const param = new URLSearchParams({
  //     id: id,
  //   });

  //   try {
  //     const res = await request(
  //       "caractivityaccidentformprint?" + param.toString(),
  //       "get",
  //       {}
  //     );
  //     await new Promise((resolve) => setTimeout(resolve, 400));
  //     console.log(res);
  //     if (res) {
  //       setPrintData(res.api_print_data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching:", error);
  //   }
  // };

  useEffect(() => {
    getList(objFilter);
  }, []);
  const columns = [
    {
      key: "id",
      title: "លេខកូដ",
      dataIndex: "id",
    },
    {
      key: "date",
      title: "ថ្ងៃខែបញ្ជូនអ្នកជំងឺ",
      dataIndex: "date_pantient",
      render: (value, item, index) => {
        return (
          <div>
            <Tag color="green">
              {dayjs(item.date_pantient).format("DD/MM/YYYY")}
            </Tag>
          </div>
        );
      },
    },
    {
      key: "name",
      title: "ឈ្មោះអ្នកជំងឺ",
      dataIndex: "name",
    },
    {
      key: "place",
      title: "ទីតាំងកើតហេតុ",
      dataIndex: "place",
    },

    {
      key: "sentTo",
      title: "បញ្ជូនជំងឺទៅ",
      dataIndex: "sentTo",
    },
    {
      key: "gender",
      title: "ភេទ",
      dataIndex: "gender",
      render: (value, item, index) => {
        return (
          <div>
            <Tag color="green">{item.gender === "Male" ? "ប្រុស" : "ស្រី"}</Tag>
          </div>
        );
      },
    },
    {
      key: "age",
      title: "អាយុ",
      dataIndex: "age",
    },
    {
      key: "phone",
      title: "លេខទំនាក់ទំនង",
      dataIndex: "phone",
    },

    {
      key: "action",
      title: "សកម្មភាព",
      dataIndex: "action",
      render: (value, item, index) => {
        return (
          <div>
            <Space key={index}>
              <Button
                disabled={!Editvalue}
                type="primary"
                onClick={() => handleEdit(item)}
                icon={<EditOutlined />}
              />

              <Button
                onClick={() => handlePrint(item)}
                type="primary"
                icon={<PrinterOutlined />}
              />

              <Popconfirm
                title="Delete the item"
                description="Are you sure to delete?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleDelete(item)}
              >
                <Button
                  danger
                  disabled={!Deletevalue}
                  type="primary"
                  icon={<CloseOutlined />}
                />
                {/* <Button danger    onClick={() => handleDelete(item)}>Delete</Button> */}
              </Popconfirm>
            </Space>
          </div>
        );
      },
    },
  ];
  const [shouldPrint, setShouldPrint] = useState(false);

  const handleDelete = async (item) => {
    try {
      const res = await request(
        `caractivityaccidentform/${item.id}`,
        "delete",
        {}
      );
      if (res) {
        message.success("Delete Successfully");
        getList(objFilter);
      }
    } catch (error) {
      console.error("Error fetching:", error);
    }
  };

  const mapFlatToInjury = (item) => {
    const updatedInjury = { ...form.injury }; // Start from default

    for (const key in item) {
      const value = item[key];

      const match = key.match(/^([a-zA-Z]+)_([a-zA-Z]+)$/); // e.g., head_wound
      if (match) {
        const [_, part, field] = match;
        if (updatedInjury[part] && field in updatedInjury[part]) {
          updatedInjury[part][field] = value === 1;
        }
      }

      if (key === "injury_other1") updatedInjury.other1 = item[key];
      if (key === "injury_other2") updatedInjury.other2 = item[key];
    }

    return updatedInjury;
  };

  const mapFlatToAccident = (item) => {
    const updatedAccident = { ...form.accident };
    for (const key in updatedAccident) {
      if (key in item) {
        updatedAccident[key] =
          typeof item[key] === "number" ? item[key] === 1 : item[key];
      }
    }
    return updatedAccident;
  };

  const mapFlatTodiagnosis = (item) => {
    const updateddiagnosis = { ...form.diagnosis };
    for (const key in updateddiagnosis) {
      if (key in item) {
        updateddiagnosis[key] =
          typeof item[key] === "number" ? item[key] === 1 : item[key];
      }
    }
    return updateddiagnosis;
  };

  const handleEdit = (item) => {
    // getPrintData(item.id);
    setID(item.id);
    try {
      setClear(1);
      const updatedInjury = mapFlatToInjury(item);
      const updatedAccident = mapFlatToAccident(item);
      const updateddiagnosis = mapFlatTodiagnosis(item);
      const timesArray = Array.from(
        { length: 6 },
        (_, i) => item[`times_${i}`] || null
      );

      setForm((prevForm) => ({
        ...prevForm,
        ...item,
        times: timesArray, // 👈 set the array here
        org_code: getProfile.org_code,
        injury: updatedInjury,
        accident: updatedAccident,
        diagnosis: updateddiagnosis,
      }));
    } catch (error) {
    } finally {
      setOpenModel(true);
    }
  };

  const onChangePage = (number) => {
    setPageNumber(number);

    setObjFileter({
      search: objFilter.search,
      page_number: number,
      item_per_page: objFilter.item_per_page,
      orgcode: getProfile.org_code,
    });
    getList(objFilter);
  };

  const [clear, setClear] = useState(0);
  const closeForm = () => {
    setOpenModel(false);
    getList(objFilter);
  };
  // Update this function to load the form and print it
  const handlePrint = (item) => {
    const updatedInjury = mapFlatToInjury(item);
    const updatedAccident = mapFlatToAccident(item);
    const updateddiagnosis = mapFlatTodiagnosis(item);
    const timesArray = Array.from(
      { length: 6 },
      (_, i) => item[`times_${i}`] || null
    );

    setID(item.id);

    setForm((prevForm) => ({
      ...prevForm,
      ...item,
      times: timesArray, // 👈 set the array here
      org_code: getProfile.org_code,
      injury: updatedInjury,
      accident: updatedAccident,
      diagnosis: updateddiagnosis,
    }));
    setShouldPrint(true); // flag to show printable component temporarily
  };

  const handlePrintComplete = () => {
    setShouldPrint(false); // Reset the flag after printing
  };
  // Print trigger after component is rendered
  useEffect(() => {
    if (shouldPrint && printRef.current) {
      setTimeout(() => {
        printComponent(); // trigger printing
      }, 500); // wait briefly to render
    }
    getList(objFilter);
  }, [shouldPrint]);
  const printComponent = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => setShouldPrint(false), // clean up
  });

  const [openModel_Filter, setOpenModel_Filter] = useState(false);
  const [filteredDate, setFilteredDate] = useState({ start: null, end: null });
  const handleFilterDateChange = async (dateRange) => {
    setFilteredDate(dateRange); // save it
    console.log("Received from FilterDate:", dateRange.start, dateRange.end);

    const newFilter = {
      ...objFilter,
      date_start: dateRange.start,
      date_end: dateRange.end,
    };
    setObjFileter(newFilter);
    getList(newFilter);
  };
  const handleClearSearch = () => {
    console.log("clear");
    const newFilter = {
      ...objFilter,
      search: "",
      date_start: null,
      date_end: null,
    };
    setObjFileter(newFilter);
    getList(newFilter);
  };
  return (
    <div>
      <div className="sprinSave-container">
        {/* Your other components */}
        {loadingSpin && (
          <div className="sprinSave">
            <GetLoading />
          </div>
        )}
      </div>

      <div style={boxHeader}>
        <div style={{ display: "flex" }}>
          <Space>
            {boxHeaderTagText("ការគ្រប់គ្រង់ ទិន្នន័យបញ្ជូនជំងឺ")}
            <div style={{ display: "flex" }}>
              <Space>
                <Input
                  onChange={(e) => {
                    const newValue = e.target.value;
                    const updatedFilter = {
                      ...objFilter,
                      search: newValue,
                    };
                    setObjFileter(updatedFilter);
                    console.log("key change:", newValue);
                    getList(updatedFilter); // Use updated filter directly
                  }}
                  placeholder="ស្វែងរក...."
                />
                <Button
                  type="primary"
                  onClick={() => {
                    setOpenModel_Filter(true);
                  }}
                  icon={<FilterOutlined />}
                />
                <Button
                  danger
                  type="primary"
                  onClick={handleClearSearch}
                  icon={<ReloadOutlined />}
                />
              </Space>
            </div>
          </Space>
        </div>
        <div style={{ display: "flex" }}>
          <Space>
            <Button
              disabled={!Addvalue}
              className="buttonstylekhmer"
              type="primary"
              icon={<BsDownload />}
            >
              ទាញយករបាយការណ៍ (Excel)
            </Button>
            <Button
              disabled={!Addvalue}
              onClick={() => {
                setOpenModel(true);
                setID(null);
                setClear(0);
              }}
              className="buttonstylekhmer"
              type="primary"
              icon={<PlusCircleOutlined />}
            >
              បង្កើតថ្មី
            </Button>
          </Space>
        </div>
      </div>
      <div>
        {loading ? (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        ) : (
          <Table
            pagination={{
              pageSize: 10,
              total: total,
              current: pageNumber,
              onChange: (page) => onChangePage(page), // ✅ Pass the new page number
            }}
            key={"key"}
            columns={columns}
            size="small"
            dataSource={list}
          />
        )}
      </div>
      <Modal
        width={1000}
        onClose={closeForm}
        footer={false}
        open={openModel}
        title={id ? "កែប្រែ" : "បង្កើតថ្មី"}
      >
        <FormPantient
          shouldPrint={shouldPrint}
          onPrintComplete={handlePrintComplete} // <-- optional callback
          closeModel={closeForm}
          update_form={form}
          onSaveSuccess={() => {
            getList(objFilter);
            console.log("on save succes refreush : ");
          }}
          updateid={id}
          cleardata={clear}
        />
      </Modal>
      <div ref={printRef} className="print-only">
        <FormPantient update_form={form} updateid={id} />
      </div>

      <Modal title="ស្វែងរក" open={openModel_Filter} footer={false}>
        <FilterDate
          closeModelFilter={() => setOpenModel_Filter(false)}
          onFilterDateChange={handleFilterDateChange}
        />
      </Modal>
    </div>
  );
};
export default AccidentForm;
